module.exports = __webpack_public_path__ + "static/media/holiday4.04e08f06.webp";